import { api } from "./api";

const parseBrowser = (ua) => {
  if (/Edg\//.test(ua)) return "Edge";
  if (/OPR\/|Opera/.test(ua)) return "Opera";
  if (/SamsungBrowser/.test(ua)) return "Samsung Internet";
  if (/Firefox\//.test(ua)) return "Firefox";
  if (/Chrome\//.test(ua)) return "Chrome";
  if (/Safari\//.test(ua)) return "Safari";
  return "Other";
};

const parseOS = (ua) => {
  if (/Windows/.test(ua)) return "Windows";
  if (/Android/.test(ua)) return "Android";
  if (/iPhone|iPad|iPod/.test(ua)) return "iOS";
  if (/Mac OS X/.test(ua)) return "macOS";
  if (/Linux/.test(ua)) return "Linux";
  return "Other";
};

/**
 * Records one anonymous visit per browser session for the admin dashboard.
 * Skips bots, "Do Not Track" visitors and repeat page loads in the same session.
 */
export async function trackVisit() {
  try {
    const ua = navigator.userAgent || "";
    if (navigator.doNotTrack === "1" || /bot|crawl|spider|headless|lighthouse/i.test(ua)) return;
    if (sessionStorage.getItem("visitSent") === "1") return;
    sessionStorage.setItem("visitSent", "1");

    let geo = {};
    try {
      const g = await api("/api/geo");
      if (g && !g.error) geo = g;
    } catch (e) {
      // geo lookup is optional
    }

    await api("/api/visitor", {
      method: "POST",
      body: {
        visitedAt: new Date().toISOString(),
        page: window.location.pathname.slice(0, 250),
        referrer: (document.referrer || "").slice(0, 250),
        browser: parseBrowser(ua),
        os: parseOS(ua),
        screen: `${window.screen.width}x${window.screen.height}`,
        lang: (navigator.language || "").slice(0, 20),
        timezone: (Intl.DateTimeFormat().resolvedOptions().timeZone || "").slice(0, 60),
        ip: geo.ip || null,
        city: geo.city || null,
        region: geo.region || null,
        country: geo.country_name || null,
        countryCode: geo.country_code || null,
      },
    });
  } catch (e) {
    // analytics must never break the site
  }
}
